import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { loginUser } from "../api/loginUser";
import { LoginSuccess, LoginFailure } from "../../../redux/user/user.actions";

export const useLogin = () => {
  const dispatch = useDispatch();

  return useMutation({
    // The backend sets the session as an httpOnly cookie on a successful
    // login response — there is no token in the response body to store on
    // the client anymore, so there's nothing to persist here beyond the
    // Redux auth state itself.
    mutationFn: ({ email, password }) =>
      loginUser({ email, password }).then((data) => {
        if (data.success) {
          dispatch(LoginSuccess(data.result?.adminData));
          return data;
        } else {
          dispatch(LoginFailure(data));
          throw new Error(data.error || "Login failed");
        }
      }),
    onError: (error) => {
      dispatch(LoginFailure({ error: error.message }));
    },
  });
};
